import Api from './api';

export const getByUserId = async (userId) => {
  let data = { success: false, data: [] };
  await Api.get(`/userskills/user/${userId}`)
    .then(result => {
      data = result.data;
    })
    .catch(err => {
      data = { success: false, errors: [err.response?.data?.errors?.[0] || 'Erro ao carregar habilidades'] };
    });
  return data;
};

export const create = async (skill) => {
  let data = null;
  await Api.post('/userskills', skill)
    .then(result => {
      data = result.data;
    })
    .catch(err => {
      data = { success: false, errors: [err.response?.data?.errors?.[0] || 'Erro ao criar habilidade'] };
    });
  return data;
};

export const update = async (skill) => {
  let data = null;
  await Api.put('/userskills', skill)
    .then(result => {
      data = result.data;
    })
    .catch(err => {
      data = { success: false, errors: [err.response?.data?.errors?.[0] || 'Erro ao atualizar habilidade'] };
    });
  return data;
};

export const remove = async (skillId) => {
  let data = null;
  await Api.delete(`/userskills/${skillId}`)
    .then(result => {
      data = result.data;
    })
    .catch(err => {
      data = { success: false, errors: [err.response?.data?.errors?.[0] || 'Erro ao excluir habilidade'] };
    });
  return data;
};
